import {useEffect, useState} from "react";
import { connect } from "react-redux"
import BVASplitter from "../../../../components/BVASplitter/BVASplitter";

import {
  generateStockDealSplitReport,
  updateStockDealSplitReport
} from "../../../../store/modules/financials/actions";
import StockDealSplitReport from "../../../../models/transactions/StockDealSplitReport";
import {Divider} from "@mui/material";

function StockDealSplit({
  stockDealSplitReport,
  currentGoodwillReport,
  currentCompanyBalanceSheetReport,
  dispatchGenerateStockDealSplitReport,
  dispatchUpdateStockDealSplitReport
}) {
  // Assets
  const [totalAssetsBuyerBuys, setTotalAssetsBuyerBuys] = useState(0)
  const [equalsAmountBuyerPaysSellerInCashAndNotes, setEqualsAmountBuyerPaysSellerInCashAndNotes] = useState(0)
  const [sellerNetInCashNotesAndRetainedAssets, setSellerNetInCashNotesAndRetainedAssets] = useState(0)
  const [goodwillCheck, setGoodwillCheck] = useState(0)

  // Mounted
  useEffect(() => {
      dispatchGenerateStockDealSplitReport()
  }, [])

  // Watchers
  useEffect(() => {
    if (
      stockDealSplitReport
      && stockDealSplitReport instanceof(StockDealSplitReport)
      && currentGoodwillReport
    ) {
      setTotalAssetsBuyerBuys(stockDealSplitReport?.getTotalAssetsBuyerBuys({
        businessGoodwill: currentGoodwillReport.goodwillAmount
      }))

      setEqualsAmountBuyerPaysSellerInCashAndNotes(
        stockDealSplitReport.getEqualsAmountBuyerPaysSellerInCashAndNotes({
          businessGoodwill: currentGoodwillReport.goodwillAmount
        })
      )

      setSellerNetInCashNotesAndRetainedAssets(stockDealSplitReport.getSellerNetInCashNotesAndRetainedAssets({
        businessGoodwill: currentGoodwillReport.goodwillAmount
      }))

      setGoodwillCheck(stockDealSplitReport.getGoodwillCheck({
        businessGoodwill: currentGoodwillReport.goodwillAmount,
        equityValueOfBusiness: currentGoodwillReport.equityValueOfBusiness
      }))
    }
  }, [currentGoodwillReport, stockDealSplitReport])


  const handleStockDealSplit = ({ stockDealSplitReportKey, stockDealOwner, stockDealItemValue }) => {
    dispatchUpdateStockDealSplitReport({ stockDealSplitReportKey }, {
      stockDealOwner,
      stockDealItemValue
    })
  }


  return (
    <div className="w-full" style={{ maxWidth: "64em" }}>
      <div>
        <div className="flex align-center">
          <label className="font-bold text-xl text-center w-1/2">Assets Seller Keeps</label>
          <label className="font-bold text-xl text-center w-1/2">Assets Buyer Buys</label>
        </div>

        <div className="mt-10">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {stockDealSplitReport?.currentAssetsSplit?.map((asset, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={asset.name}
                  itemValue={asset.value}
                  itemSplitAmount={asset.amountFormatted}
                  itemSplitValue={asset.stockDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    stockDealSplitReportKey: "currentAssetsSplit",
                    stockDealOwner: stockDealSplitValue,
                    stockDealItemValue: asset.value
                })} />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Current Assets</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalCurrentAssetsSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Current Assets</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalCurrentAssetsBuyerBuysFormatted}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {stockDealSplitReport?.longTermAssetsSplit?.map((asset, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={asset.name}
                  itemValue={asset.value}
                  itemSplitAmount={asset.amountFormatted}
                  itemSplitValue={asset.stockDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    stockDealSplitReportKey: "longTermAssetsSplit",
                    stockDealOwner: stockDealSplitValue,
                    stockDealItemValue: asset.value
                  })}
                />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Long Term Assets</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalLongTermAssetsSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Long Term Assets</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalLongTermAssetsBuyerBuysFormatted}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5">
          <div className="border border-neutral-300 p-8 rounded-lg">
            <div className="w-full flex items-center align-center justify-between">
              <div className="w-80" />
              <div className="w-80" />
              <div className="w-80 font-semibold">Total Tangible Assets</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalTangibleAssetsBuyerBuysFormatted}
              </div>
            </div>
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80" />
              <div className="w-80" />
              <div className="w-80 font-semibold">Business Goodwill</div>
              <div className="w-40 text-center">
                {currentGoodwillReport?.formattedGoodwillAmount}
              </div>
            </div>
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Assets</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalAssetsSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Assets</div>
              <div className="w-40 text-center">
                {totalAssetsBuyerBuys}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-14">
        <div className="flex align-center">
          <label className="font-bold text-xl text-center w-1/2">Debts Seller Pays Off</label>
          <label className="font-bold text-xl text-center w-1/2">Debts Seller Assumes</label>
        </div>

        <div className="mt-10">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {stockDealSplitReport?.currentLiabilitiesSplit?.map((liability, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={liability.name}
                  itemValue={liability.value}
                  itemSplitAmount={liability.amountFormatted}
                  itemSplitValue={liability.stockDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    stockDealSplitReportKey: "currentLiabilitiesSplit",
                    stockDealOwner: stockDealSplitValue,
                    stockDealItemValue: liability.value
                  })}
                />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Current Liabilities</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalCurrentLiabilitiesSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Current Liabilities</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalCurrentLiabilitiesBuyerBuysFormatted}
              </div>
            </div>
          </div>

        </div>

        <div className="mt-5">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {stockDealSplitReport?.longTermLiabilitiesSplit?.map((liability, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={liability.name}
                  itemValue={liability.value}
                  itemSplitAmount={liability.amountFormatted}
                  itemSplitValue={liability.stockDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    stockDealSplitReportKey: "longTermLiabilitiesSplit",
                    stockDealOwner: stockDealSplitValue,
                    stockDealItemValue: liability.value
                  })}
                />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Long Term Liabilities</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalLongTermLiabilitiesSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Long Term Liabilities</div>
              <div className="w-40 text-center">
                {stockDealSplitReport?.totalLongTermLiabilitiesBuyerBuysFormatted}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16">
        <h3 className="font-bold text-center text-2xl">Deal Structure</h3>
        <div className="mt-14">
          <div className="flex justify-between items-center mb-4 px-5 rounded-lg">
            <label className="whitespace-nowrap">(+) Total Assets Purchased by Buyer</label>
            <label className="whitespace-nowrap">{totalAssetsBuyerBuys}</label>
          </div>
          <div className="flex justify-between items-center mb-2 px-5 rounded-lg">
            <label className="whitespace-nowrap">(-) Subtract Liabilities Assumed by Buyer</label>
            <label className="whitespace-nowrap">{stockDealSplitReport?.totalLiabilitiesAssumedByBuyerFormatted}</label>
          </div>
          <Divider />
          <div className="flex justify-between items-center mt-2 mb-6 px-5 rounded-lg">
            <label className="whitespace-nowrap font-semibold">Cash and Note at Close of Escrow from Buyer</label>
            <label className="whitespace-nowrap">{equalsAmountBuyerPaysSellerInCashAndNotes}</label>
          </div>
          <div className="flex justify-between items-center mb-4 px-5 rounded-lg">
            <label className="whitespace-nowrap">(+) Plus Assets Seller Keeps</label>
            <label className="whitespace-nowrap">{stockDealSplitReport?.totalAssetsSellerKeepsFormatted}</label>
          </div>
          <div className="flex justify-between items-center mb-4 px-5 rounded-lg">
            <label className="whitespace-nowrap">(-) Minus Liabilities Seller Pays Off</label>
            <label className="whitespace-nowrap">{stockDealSplitReport?.totalLiabilitiesSellerKeepsFormatted}</label>
          </div>
          <div className="flex justify-between items-center bg-neutral-100 mb-4 p-5 rounded-lg">
            <label className="whitespace-nowrap font-bold"> Seller's Net in Cash, Notes & Retained Assets</label>
            <label className="whitespace-nowrap font-bold">{sellerNetInCashNotesAndRetainedAssets}</label>
          </div>
        </div>
        <div className="mt-2">
          <div className="flex justify-between items-center bg-neutral-100 p-5 rounded-lg">
            <label className="whitespace-nowrap font-bold">Goodwill Check</label>
            <label className="whitespace-nowrap font-bold">{goodwillCheck}</label>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
 dispatchGenerateStockDealSplitReport() {
   dispatch(generateStockDealSplitReport())
 },

  dispatchUpdateStockDealSplitReport({ stockDealSplitReportKey }, {
    stockDealOwner,
    stockDealItemValue
  }) {
   dispatch(updateStockDealSplitReport({ stockDealSplitReportKey }, {
     stockDealOwner,
     stockDealItemValue
   }))
  }
})

const mapStateToProps = (state) => ({
  stockDealSplitReport: state.financials.stockDealSplitReport,
  currentGoodwillReport: state.financials.currentGoodwillReport,
  currentCompanyBalanceSheetReport: state.financials.currentCompanyBalanceSheetReport
})


export default connect(mapStateToProps, mapDispatchToProps)(StockDealSplit)